/**
 * Config API (API key, base URL)
 */

import { getApiBase, resolveApiBaseUrl } from './fetch';

export function setApiKey(key: string): void {
  localStorage.setItem('danny_api_key', key);
}

export function clearApiKey(): void {
  localStorage.removeItem('danny_api_key');
}

export async function testApiKey(key: string): Promise<boolean> {
  try {
    const apiBase = getApiBase();
    const response = await fetch(`${apiBase}/views`, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': key,
      },
    });
    return response.ok;
  } catch {
    return false;
  }
}

export function getApiBaseUrl(): string {
  return resolveApiBaseUrl() || '(using proxy)';
}
